// extracted by mini-css-extract-plugin
module.exports = {"root":"TimeFilterControl_root__sZpFY","calendarIcon":"TimeFilterControl_calendarIcon__8x_wX","leftOffset":"TimeFilterControl_leftOffset__jAND5"};